export default "__VITE_ASSET__9JGb4XXl__"